import axios from 'axios';

const isBrowser = typeof window !== 'undefined';
const isLocalHost = isBrowser && ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
const baseURL = isBrowser && !isLocalHost
  ? window.location.origin
  : process.env.REACT_APP_API_URL || 'http://localhost:5088';

const httpClient = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export default httpClient;
